import { environment } from 'src/environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { ProfileService } from 'src/app/core/services/profile.service';
import { WipodService } from 'src/app/core/services/wipod.service';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';

@Component({
  selector: 'app-collaboration',
  templateUrl: './collaboration.component.html',
  styleUrls: ['./collaboration.component.scss']
})
export class CollaborationComponent implements OnInit {

  @Input() public content_id: any;
  @Input() public collaborationData: any;

  collabForm: FormGroup;
  connections: any = [];
  // isLoading: boolean = false;
  isSubmitted: boolean = false;
  imageURL: any = environment.url;
  selectedUser: any = [];
  isContentLoading: boolean = false;
  textAreaLength: any = 0;
  hasError: boolean = false;
  error: string;

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private _profileService: ProfileService,
    private _wipodService: WipodService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.contentFormBuilder();
    this.loadConnections();
  }

  contentFormBuilder() {
    this.collabForm = this.formBuilder.group({
      recipient_id: [(this.collaborationData) ? (this.collaborationData.recipient.id) : null, Validators.required],
      permission: [(this.collaborationData) ? (this.collaborationData.permission) : 'review', Validators.required],
      no_of_days: [(this.collaborationData) ? (this.collaborationData.no_of_days) : '', Validators.compose([Validators.required, Validators.min(1), Validators.max(45)])],
      note: [(this.collaborationData) ? (this.collaborationData.note) : '', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.TEXT_AREA)])],
    });
  }

  loadConnections() {
    this.isContentLoading = true;
    this._profileService.fetchConnections().subscribe(
      (response: any) => {
        this.isContentLoading = false;
        if (response.success) {
          if (this.collaborationData) {
            this.connections = response.data.connections.filter((e) => {
              return e.user.id == this.collaborationData.recipient.id;
            })
          }
          else {
            this.connections = response.data.connections;
          }
          if (this.connections.length > 0) {

            this.selectedUser = this.connections[0];

            this.collabForm.patchValue({
              recipient_id: this.connections[0].user.id
            });

            this.connections.forEach(element => {
              if (element.user.name) {
                element.name = element.user.name;
              }
            });
          }
        }
      });
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 1) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");

    let no_of_days = (this.collabForm.controls.no_of_days.value) ? (this.collabForm.controls.no_of_days.value.toString() + filteredText) : filteredText
    this.collabForm.patchValue({
      no_of_days: no_of_days.substring(0, 2)
    });
    event.preventDefault();
  }

  onUserChange(event) {
    this.hasError = false;
    this.selectedUser = this.connections.filter((e) => {
      return e.user.id == event.target.value
    });
    this.selectedUser = this.selectedUser[0];
  }

  submitCollaboration() {
    this.isSubmitted = true;
    if (this.collabForm.invalid) {
      return;
    }
    this.isContentLoading = true;
    const param = {
      ...this.collabForm.value,
      content_id: this.content_id
    }
    this._wipodService.createCollaborationRequest(param).subscribe(
      (response) => {
        this.isContentLoading = false;
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.message;
          this.closeDialog(true);
        }
        else if (Array.isArray(response.errors)) {
          if (response.errors[0].detail.includes('already made a collaboration request') || response.errors[0].detail.includes(`can't collaboarte with this`)) {
            this.hasError = true;
            this.error = response.errors[0].detail;
          }
          else {
            const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modelRef.componentInstance.message = response.errors[0].detail;
            modelRef.componentInstance.forModal = 'wipod';
            // this.closeDialog(true);
          }
        }
        else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
          modelRef.componentInstance.forModal = 'wipod';
          // this.closeDialog(true);
        }
      });
  }

  updateCollaboration() {
    this.isSubmitted = true;
    if (this.collabForm.invalid) {
      return;
    }
    this.isContentLoading = true;
    const param = {
      "collaboration": {
        ...this.collabForm.value
      }
    }
    delete param.collaboration.recipient_id;

    this._wipodService.updateCollaboration(this.collaborationData.id, param).subscribe(
      (response: any) => {
        this.isContentLoading = false;
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.message;
          this.closeDialog(true);
        }
        else {
          const modelRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.errors;
          modelRef.componentInstance.forModal = 'wipod';
        }
      });
  }

  closeDialog(status) {
    if (status)
      this.activeModal.close();
    else
      this.activeModal.dismiss();
  }

  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
  }
}
